import {z} from 'zod';

import i18n from '@/i18n';

export const rejectWorkTimeEntryFormSchema = z.object({
  note: z.string().trim().min(1, i18n.t('Reason is required')),
});

export type RejectWorkTimeEntryFormValues = z.infer<
  typeof rejectWorkTimeEntryFormSchema
>;

export const updateWorkTimeEntryFormSchema = z
  .object({
    startedAt: z.string().min(1, i18n.t('Start time is required')),
    endedAt: z.string().min(1, i18n.t('End time is required')),
    note: z.string(),
  })
  .refine(values => new Date(values.endedAt) >= new Date(values.startedAt), {
    message: i18n.t('End time must be after start time'),
    path: ['endedAt'],
  });

export type UpdateWorkTimeEntryFormValues = z.infer<
  typeof updateWorkTimeEntryFormSchema
>;

export const createWorkTimeEntryFormSchema = z
  .object({
    userId: z.string().trim().min(1, i18n.t('Employee is required')),
    startedAt: z.string().min(1, i18n.t('Start time is required')),
    endedAt: z.string().min(1, i18n.t('End time is required')),
    note: z.string(),
  })
  .refine(values => new Date(values.endedAt) >= new Date(values.startedAt), {
    message: i18n.t('End time must be after start time'),
    path: ['endedAt'],
  });

export type CreateWorkTimeEntryFormValues = z.infer<
  typeof createWorkTimeEntryFormSchema
>;
